import React from "react";
import { withAppLayout } from "../../hoc";
import FullTransactionReportContainer from "../../containers/FullTransactionReportContainer/FullTransactionReportContainer";
const FullTransactionReport = (props) => {
  return <FullTransactionReportContainer {...props} />;
};
export default withAppLayout(FullTransactionReport);
